import { GagePosition } from "@app/strain/config/gages/models/gage-position.enum";
import { Model } from "@app/strain/config/gages/models/model.model";
import { Gage } from "@app/strain/config/gages/models/gage.model";

export class StrainMeasurementGageDetailsModel {
    public name: string;
    public gage: Gage;
    public position: GagePosition;

    constructor(entry: any = {}) {
        this.name = entry.name;
        this.gage = entry.gage;
        this.position = entry.position;
    }
}
